import axios, { AxiosRequestConfig, Method } from "axios";
import Storage from "@/utils/store";

interface Option extends AxiosRequestConfig {
  url: string;
  method?: Method;
  data?: any;
  tip?: boolean;
}

const signOutGohome = () => {
  Storage.s.clear();
  Storage.l.clear();
  window.location.replace("/home?needlogin=true");
};

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    try {
      if (error.response.status === "601") {
        signOutGohome();
      }
      return Promise.reject(error.message);
    } catch (err) {
      return Promise.reject(error);
    }
  }
);

/**
 * 获取接口
 * @param url
 * @param method
 * @param data
 * @param tip
 * @returns {Promise<AxiosResponse<any> | void>}
 */
export const fetch = ({
  url,
  method = "get",
  data = {},
  tip = true,
  ...datas
}: Option): Promise<any> => {
  if (!url) return Promise.reject({ code: -1, message: "no found rul" });

  const headers = datas.headers;

  if (headers) {
    delete datas.headers;
  }

  return axios
    .request({
      url,
      method,
      params: method === "get" ? data : {},
      data: method === "post" ? data : {},
      timeout: 20000,
      withCredentials: true,
      paramsSerializer: function (params) {
        const keys = Object.keys(params);

        const arr: any[] = [];

        keys.forEach((item) => {
          if (Array.isArray(params[item])) {
            if (params[item].length === 0) {
            } else {
              const url = params[item]
                .map((_: any) => `${item}=${_}`)
                .join("&");

              arr.push(url);
            }
          } else {
            if (params[item] == null) {
            } else {
              arr.push(`${item}=${params[item]}`);
            }
          }
        });

        const result = arr.join("&");

        return `${result}`;
      },
      headers: {
        Jwt: Storage.l.get("loginInfo")?.jwt || "",
        ...(headers || {}),
      },
      ...datas,
    })
    .then((res) => {
      const { code = 0, message = "服务异常" } = res.data;

      switch (code) {
        case 200:
          return res.data;
        case 601: // 用户已失效或未登录!
          return res.data;
        case 500:
          return Promise.reject(message);
        default:
          // tip && toast(message);
          return res.data;
      }
    })
    .catch((e: any): any => {
      // tip && setTimeout(() => toast('出错了，请稍后再试！'), 100);
      // console.log("fetch error==", e);

      if (typeof e === "string") {
        if (e.includes("601")) {
          signOutGohome();
        }
      }
      return Promise.reject(e);
    });
};

export const commonFetch = (
  url: string,
  isGet = true,
  data = {},
  tip = true
) => {
  return fetch({
    url,
    method: isGet ? "get" : "post",
    tip,
    data,
  })
    .then((res) => {
      return res.result;
    })
    .catch((err) => {
      // console.log("commonFetch error=", err);
      return Promise.reject(err);
    });
};
